import PageHeader from '../../../../components/Layout/Header/PageHeader'
import Text from '../../../../components/Text'
import { downloadApp, getUrlParams } from '../../../../utils/helpers/common'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import MySaathiLogo from '../../../../assets/images/sema-onboarding/mysaathi-logo.webp'
import AppScreenshot from '../../../../assets/images/sema-onboarding/app-screenshot.webp'
import WarningIcon from '../../../../assets/icons/warning-with-circle.png'
import PageFooter from '../PageFooter'
import Button from '../../../../components/ButtonNew'
import WhatsAppIcon from '../../../../components/Icons/WhatsAppIcon'
import constants from '../../../../constants'
import { trackEvent } from '../../../../analytics'
import { EVENTS } from '../../../../analytics/events'
import { useDispatch } from 'react-redux'
import * as actions from '../../../../store/slices/index'

const BlockerPage = () => {
  const { variant } = useParams()
  const params = getUrlParams()
  const navigate = useNavigate()
  const [downloading, setDownloading] = useState(false)
  const programName = constants.GOOD_FLIP_SOURCE.toLowerCase()
  const isGoodFlip = params?.support_program_name === programName
  const dispatch = useDispatch()
  const handleOnBack = () => {
    tryAnotherNumber()
  }
  const handleOnContinue = () => {
    setDownloading(true)
    setTimeout(() => {
      downloadApp()
    }, 10)
  }

  const handleOnContact = () => {
    // TODO: handle the whatsApp message
  }
  const tryAnotherNumber = () => {
    dispatch(actions.resetUserDetails())
    navigate(`/${variant || SEMAGLYN}/register`)
  }

  useEffect(() => {
    trackEvent(EVENTS.PAGE_VIEW, {
      screenName: isGoodFlip ? 'already GF member' : 'already mysaathi member',
      ...params,
    })
  }, [])

  useEffect(() => {
    if (downloading) {
      setTimeout(() => {
        setDownloading(false)
      }, 1000)
    }
  }, [downloading])

  const contentObject = {
    mysaathi: {
      bg: 'bg-[linear-gradient(0deg,_#FFF_60%,_#D1FADF_100%)]',
      title: 'You are already a MySaathi member',
      description:
        'You are already a part of the <b>MySaathi</b> program. Tap on the button below to continue your journey on the  <b>GoodFlip application</b>',
      headerImage: MySaathiLogo,
      headerImageSize: {
        width: 123,
        height: 24,
      },
      buttons: [
        {
          label: 'Download GoodFlip App',
          variant: 'contained',
          size: 'xSmall',
          fullWidth: true,
          onClick: handleOnContinue,
        },
      ],
    },
    goodflip: {
      bg: 'bg-[linear-gradient(0deg,_#FFF_60%,_#FEF0C7_100%)]',
      title: 'You are already on a GoodFlip program',
      description:
        'It seems that you are already a part of one of the GoodFlip program. You can try <b>registering with a different number</b> or <b>contact our team</b> for the best resolution',
      headerImage: WarningIcon,
      headerImageSize: {
        width: 60,
        height: 60,
      },
      buttons: [
        {
          label: 'Contact Support',
          variant: 'outlined',
          size: 'xSmall',
          icon: WhatsAppIcon,
          fullWidth: true,
          onClick: handleOnContact,
        },
        {
          label: 'Try Another Number',
          variant: 'contained',
          size: 'xSmall',
          fullWidth: true,
          onClick: tryAnotherNumber,
        },
      ],
    },
  }

  const content = contentObject[isGoodFlip ? programName : 'mysaathi']
  return (
    <div className={`min-h-screen flex flex-col ${content.bg}`}>
      <PageHeader handleOnBack={handleOnBack} />

      {/* Main Content */}
      <div className="flex flex-col items-center flex-1 px-4 text-center gap-2 pb-32">
        <img
          src={content.headerImage}
          width={content.headerImageSize.width}
          height={content.headerImageSize.height}
          alt="mySaathi-logo"
          className="object-scale-down mt-6"
        />
        <Text
          tag="p"
          variant="headline"
          size="small"
          textalign="center"
          className="text-[#101828] mb-4 mt-4"
        >
          {content.title}
        </Text>
        <Text
          tag="p"
          variant="body"
          size="medium"
          textalign="center"
          className="text-[#344054] mb-8 max-w-md"
          dangerouslySetInnerHTML={{ __html: content.description }}
        />
        {/* Images */}
        <div className="">
          {/* Placeholder phone images */}
          <img
            src={AppScreenshot}
            alt="app-screenshot"
            height={264}
            // className="w-24 h-44 object-contain rounded-xl shadow-md -rotate-6"
          />
        </div>

        <span className="flex-1" />
        <PageFooter />
      </div>
      <div className="fixed bottom-0 left-0 right-0 p-4 min-w-sm max-w-lg mx-auto w-full bg-white">
        <div className="flex gap-2 items-center">
          {content.buttons.map((button) => (
            <Button
              key={button.label}
              onClick={button.onClick}
              fullWidth
              variant={button.variant}
              size={button.size}
            >
              {button.icon && <button.icon className="w-4 h-4" />}
              {button.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default BlockerPage
